'use strict';

export interface IState {
    [index: string]: boolean;
}

export default {
    ison_deposit_invoice_request: false
};
